import Hero from "@/components/site/Hero";
import TabStrip from "@/components/site/TabStrip";
import CapabilityGrid from "@/components/site/CapabilityGrid";
import WhyHapo from "@/components/site/WhyHapo";
import PartnersStrip from "@/components/site/PartnersStrip";
import FeaturedWork from "@/components/site/FeaturedWork";
import Insights from "@/components/site/Insights";
import { CountUp, Reveal, GoldButton, OutlineButton } from "@/components/site/motion";
import { useSEO } from "@/hooks/useSEO";

const stats = [
  { to: 9, label: "Operating companies" },
  { to: 5, label: "One connected value chain" },
  { to: 5, label: "Anchor global partners" },
  { to: 1, label: "Group, one strategy" },
];

export default function Home() {
  useSEO(
    "Hapo Group — The Group That Connects",
    "Hapo Group brings together technology, cloud & AI, media, fintech, electronics manufacturing, green energy, consumer intelligence, business music and extended reality under one South African holding company."
  );

  return (
    <>
      <Hero />
      <TabStrip />

      <section className="border-y border-white/10 bg-ink px-6 py-16 lg:px-12 lg:py-20" aria-label="Group at a glance">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          {stats.map((s) => (
            <Reveal key={s.label} data-testid={`stat-${s.label}`}>
              <CountUp to={s.to} className="text-5xl font-extrabold tracking-tighter text-white lg:text-7xl" />
              <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.22em] text-smoke">{s.label}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <CapabilityGrid />
      <WhyHapo />
      <PartnersStrip />
      <FeaturedWork />
      <Insights />

      <section className="border-t border-white/10 bg-ink px-6 py-28 text-center lg:px-12 lg:py-[180px]" aria-label="Final call to action">
        <Reveal>
          <h2 className="mx-auto max-w-5xl text-4xl font-extrabold leading-[1.02] tracking-tighter text-white sm:text-5xl lg:text-7xl">
            Looking to partner with Hapo Group, invest, or build your career with us?
          </h2>
          <div className="mt-14 flex flex-wrap justify-center gap-4">
            <GoldButton to="/partnerships" testId="cta-explore-partnerships">
              Explore Partnerships
            </GoldButton>
            <OutlineButton to="/contact" testId="cta-get-in-touch">
              Get in Touch
            </OutlineButton>
          </div>
        </Reveal>
      </section>
    </>
  );
}
